<template>
    <div class="tjpopup" v-show="dataVal.flag" @click.stop="handleRefund">
        <div class="tj" @click.stop>
            <div class="tj_head">
                <div class="tj_head_title">目录重排</div>
            </div>
            <draggable v-model="navlist" group="people" @end="dragend" class="tj_list">
                <div class="tj_list_item" v-for="(item, index) in navlist" :key="item.id">{{ item.name }}</div>
            </draggable>
            <div class="tj_foot">
                <div class="tj_foot_btn" @click="handleRefund">取消</div>
                <div class="tj_foot_btn tj_foot_btn2" @click="handleSubmit">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
    name: 'editdata',
    props: ['dataVal'],
    components: {
        draggable,
    },
    data() {
        return {
            navlist: []
        }
    },
    methods: {
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("dragmenuCal", data);
        },
        handleSubmit() {
            let obj = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                navlist: this.navlist
            }
            this.$emit("dragmenuCal", obj);
        },
        // 拖拽结束
        dragend(event, item, index) {
            // console.log("end");
            // event.item  拖拽的本身
            // event.to      拖拽的目标列表
            // event.from    拖拽之前的列表
            // event.oldIndex    拖拽前的位置
            // event.newIndex    拖拽后的位置
            // console.log(event);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.navlist = newVal.navlist
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
.tjpopup {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .tj {
        min-width: 250px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;

        .tj_head {
            width: 100%;
            height: 50px;
            background-color: #f6f6f6;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 20px;

            .tj_head_title {
                font-size: 16px;
                color: #333333;
                cursor: default;
            }
        }

        .tj_list {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .tj_list_item {
                width: 100%;
                height: 50px;
                font-size: 14px;
                color: #333333;
                border-bottom: 1px solid #f5f5f5;
                display: flex;
                align-items: center;
                padding: 0 29px;
                cursor: default;
            }
        }

        .tj_foot {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 40px;
            margin-top: 30px;

            .tj_foot_btn {
                width: 80px;
                height: 32px;
                font-size: 14px;
                color: #606266;
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #dbdbdb;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }

            .tj_foot_btn2 {
                color: #ffffff;
                background-color: #e64a19;
                border: solid 1px #e64a19;
            }
        }
    }
}
</style>